import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitofivejyotilingadarshan() {



  const cardData = {
    keyword: " Navi Mumbai to 5 Jyotirlinga Darshan Cab   ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai to 5 Jyotirlinga Darshan cab service, providing safe, comfortable, and spiritually enriching travel for devotees and families. The 5 Jyotirlinga circuit in Maharashtra typically includes Trimbakeshwar (Nashik), Bhimashankar (Pune), Grishneshwar (Aurangabad), Parli Vaijnath (Beed), and Aundha Nagnath (Hingoli). This sacred pilgrimage usually takes 3–5 days depending on the route and travel plan. Our professional drivers are experienced in pilgrimage routes, ensuring smooth travel, timely darshan, and hassle-free journey. We offer customized packages including one-way, round trip, and multi-day tours with flexible stops. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai to 5 Jyotirlinga Darshan cab service.",

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga (Nashik)",
    "description": "Trimbakeshwar Jyotirlinga, located near Nashik, is one of the most sacred Jyotirlingas dedicated to Lord Shiva. It is uniquely known for its three-faced linga representing Brahma, Vishnu, and Mahesh. The temple is situated near the origin of the Godavari River, adding to its spiritual importance. Devotees visit this temple for performing rituals like Narayan Nagbali and Kaal Sarp Dosh puja. The serene surroundings of the Brahmagiri hills and the sacred atmosphere make it a must-visit destination in the 5 Jyotirlinga yatra. Pilgrims often spend extra time here for darshan and religious ceremonies."
  },
  {
    "title": "Bhimashankar Jyotirlinga (Pune)",
    "description": "Bhimashankar Jyotirlinga is located in the Sahyadri hills near Pune and is surrounded by dense forests and wildlife sanctuary. It is one of the most scenic Jyotirlingas, offering a combination of spirituality and natural beauty. The temple is associated with the legend of Lord Shiva defeating the demon Bhima. Devotees often combine darshan with trekking and nature exploration, especially during monsoon and winter seasons. The peaceful forest environment enhances the spiritual experience, making it a unique stop in the yatra."
  },
  {
    "title": "Grishneshwar Jyotirlinga (Aurangabad)",
    "description": "Grishneshwar Jyotirlinga, located near Ellora Caves in Aurangabad, is the last of the twelve Jyotirlingas. The temple is known for its beautiful red stone architecture and intricate carvings. Devotees can enter the sanctum to perform abhishek, making it a deeply spiritual experience. Its proximity to the UNESCO World Heritage site Ellora Caves makes it a popular destination for both pilgrims and tourists. The temple holds great religious significance and is an essential part of the 5 Jyotirlinga circuit."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga (Beed)",
    "description": "Parli Vaijnath Jyotirlinga is an important temple dedicated to Lord Shiva and is believed to have healing powers. Devotees visit this temple seeking relief from illnesses and spiritual upliftment. The temple is well-maintained and attracts pilgrims throughout the year. Its peaceful surroundings and religious significance make it an important stop during the yatra. Many devotees consider this temple essential for completing the Jyotirlinga pilgrimage in Maharashtra."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga (Hingoli)",
    "description": "Aundha Nagnath Jyotirlinga is one of the oldest temples dedicated to Lord Shiva and is believed to be the first Jyotirlinga by some traditions. The temple has ancient architecture and deep spiritual significance. It is associated with various legends from Hindu mythology and is visited by thousands of devotees every year. The calm environment and historical importance make it a peaceful yet powerful spiritual destination."
  },
  {
    "title": "Ellora Caves (Nearby Attraction)",
    "description": "Ellora Caves, located near Grishneshwar, are a UNESCO World Heritage Site known for their magnificent rock-cut architecture and ancient temples. Visitors can explore Hindu, Buddhist, and Jain caves, including the famous Kailasa Temple. Many travelers combine this visit with Jyotirlinga darshan, making it a culturally enriching experience along with the spiritual journey."
  },
  {
    "title": "Multi-Day Pilgrimage Planning",
    "description": "The 5 Jyotirlinga Darshan is usually planned over 3–5 days with a proper route covering all temples efficiently. Cab services provide experienced drivers familiar with the pilgrimage sequence, helping devotees complete darshan without confusion or delays. Travelers can opt for customized packages with hotel stays, food stops, and flexible darshan timing. This ensures a smooth, organized, and spiritually fulfilling journey without travel stress."
  },
  {
    "title": "Comfortable Long-Distance Travel",
    "description": "Since the Jyotirlinga circuit involves long-distance travel across multiple cities, comfortable vehicles play a crucial role. Options like Innova, Ertiga, and Tempo Travellers provide ample seating, legroom, and luggage space for a relaxed journey. Air-conditioned vehicles and smooth ride quality help reduce fatigue, allowing devotees to focus on their spiritual experience throughout the trip."
  },
  {
    "title": "Group & Family Pilgrimage",
    "description": "The Jyotirlinga yatra is often undertaken by families and groups, making larger vehicles a preferred choice. Traveling together enhances the spiritual experience and ensures convenience in managing the itinerary. Cab services provide suitable vehicle options for small and large groups, making the journey comfortable and well-coordinated."
  },
  {
    "title": "Safe & Hassle-Free Travel",
    "description": "Professional cab services ensure safety, reliability, and convenience throughout the pilgrimage journey. Experienced drivers are familiar with temple routes, road conditions, and travel timings, ensuring smooth navigation. Verified drivers, clean vehicles, and 24/7 support make the entire journey safe, comfortable, and stress-free for devotees."
  }
],






services: [
  {
    name: "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
    description: "Navi Mumbai to 5 Jyotirlinga darshan cab service offers a complete spiritual journey covering major Jyotirlinga temples of Maharashtra. Ideal for devotees and families, this service ensures smooth long-distance travel with experienced drivers. Comfortable vehicles enhance the yatra experience. It guarantees a peaceful and well-planned pilgrimage."
  },
  {
    name: "5 Jyotirlinga Darshan Cab from Navi Mumbai",
    description: "5 Jyotirlinga darshan cab from Navi Mumbai provides a dedicated travel solution for visiting sacred Shiva temples. This service includes flexible travel plans and route optimization. Professional drivers ensure safe journeys. It guarantees a hassle-free darshan experience."
  },
  {
    name: "Navi Mumbai 5 Jyotirlinga Yatra Cab",
    description: "Navi Mumbai 5 Jyotirlinga yatra cab is designed for devotees seeking a comfortable and organized pilgrimage tour. Clean vehicles and trained drivers ensure convenience. Ideal for multi-day trips. It guarantees a smooth spiritual journey."
  },
  {
    name: "5 Jyotirlinga Tour Package Navi Mumbai by Cab",
    description: "5 Jyotirlinga tour package Navi Mumbai by cab offers a complete travel solution including pickup, temple visits, and return journey. Ideal for families and group travel. Flexible scheduling enhances convenience. It ensures a stress-free pilgrimage."
  },
  {
    name: "Navi Mumbai to Jyotirlinga Darshan Taxi",
    description: "Navi Mumbai to Jyotirlinga darshan taxi provides private and comfortable travel for visiting sacred Shiva temples. This service ensures door-to-door pickup and smooth highway travel. It guarantees a reliable journey."
  },
  {
    name: "5 Jyotirlinga Darshan Yatra Cab",
    description: "5 Jyotirlinga darshan yatra cab offers a well-planned route for visiting all major Jyotirlinga temples. Ideal for religious travel and family trips. Comfortable seating enhances long-distance journeys. It guarantees a fulfilling yatra experience."
  },
  {
    name: "Jyotirlinga Darshan Cab Service Navi Mumbai",
    description: "Jyotirlinga darshan cab service Navi Mumbai ensures dependable transportation with experienced drivers and well-maintained vehicles. Suitable for pilgrimage tours and group travel. It guarantees a safe and comfortable journey."
  },
  {
    name: "Maharashtra 5 Jyotirlinga Darshan Cab",
    description: "Maharashtra 5 Jyotirlinga darshan cab covers popular temples like Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Ideal for devotees planning a complete spiritual tour. It ensures smooth and organized travel."
  },
  {
    name: "Jyotirlinga Tour Cab from Navi Mumbai",
    description: "Jyotirlinga tour cab from Navi Mumbai provides a convenient travel option for visiting sacred temples across Maharashtra. Flexible travel plans and comfortable vehicles enhance the journey. It guarantees a stress-free pilgrimage."
  },
  {
    name: "Lord Shiva Jyotirlinga Darshan Cab",
    description: "Lord Shiva Jyotirlinga darshan cab offers a dedicated travel experience for devotees seeking spiritual connection. Professional drivers ensure safe and smooth journeys. Comfortable vehicles enhance long-distance travel. It guarantees a peaceful darshan experience."
  },
  {
    name: "AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai",
    description: "AC cab for 5 Jyotirlinga darshan from Navi Mumbai provides comfortable travel in air-conditioned vehicles. Ideal for long journeys across different weather conditions. Spacious seating ensures comfort. It guarantees a pleasant yatra."
  },
  {
    name: "Round Trip Cab Navi Mumbai to Jyotirlinga",
    description: "Round trip cab Navi Mumbai to Jyotirlinga provides complete travel solutions including return journey. Ideal for multi-day pilgrimage tours. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Private Cab for 5 Jyotirlinga Darshan",
    description: "Private cab for 5 Jyotirlinga darshan offers exclusive travel for families and groups. This service ensures privacy, comfort, and flexible scheduling. Professional drivers ensure safe journeys. It guarantees a personalized pilgrimage experience."
  }
],

tableData: [
  ["Navi Mumbai to 5 Jyotirlinga Darshan Cab", "5 Jyotirlinga Darshan Cab from Navi Mumbai"],
  ["Navi Mumbai 5 Jyotirlinga Yatra Cab", "5 Jyotirlinga Tour Package Navi Mumbai by Cab"],
  ["Navi Mumbai to Jyotirlinga Darshan Taxi", "5 Jyotirlinga Darshan Yatra Cab"],
  ["Jyotirlinga Darshan Cab Service Navi Mumbai", "Maharashtra 5 Jyotirlinga Darshan Cab"],
  ["Jyotirlinga Tour Cab from Navi Mumbai", "Lord Shiva Jyotirlinga Darshan Cab"],
  ["AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai", "Round Trip Cab Navi Mumbai to Jyotirlinga"],
  ["Private Cab for 5 Jyotirlinga Darshan", ""]
],


whychoose: [
  {
    WhyChooseheading: "Complete Navi Mumbai to 5 Jyotirlinga Darshan Travel",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Navi Mumbai to 5 Jyotirlinga cab service, ideal for spiritual journeys and family pilgrimage tours."
  },
  {
    WhyChooseheading: "Cover All Major Jyotirlinga Temples",
    WhyChoosedescription: "Our package covers 5 Jyotirlinga temples including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in temple routes, ensuring safe driving and smooth travel across multiple destinations."
  },
  {
    WhyChooseheading: "Ideal 3–5 Days Yatra Plan",
    WhyChoosedescription: "We provide flexible 3 to 5 days travel plans to comfortably complete all Jyotirlinga darshan without rush."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear fare including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible Round Trip Packages",
    WhyChoosedescription: "Choose from customized round-trip packages based on your schedule and temple visit plan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Jyotirlinga Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Navi Mumbai to 5 Jyotirlinga darshan cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai to 5 Jyotirlinga cab service?", answer: "Yes, Royal Route Cabs offers complete 5 Jyotirlinga darshan cab service from Navi Mumbai." },
  { question: "Which Jyotirlingas are covered in this tour?", answer: "The tour includes Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath." },
  { question: "How many days are required for this yatra?", answer: "The journey typically takes 3 to 5 days depending on travel plan." },
  { question: "What is the total distance for the tour?", answer: "The total distance is approximately 900 to 1200 km depending on route." },
  { question: "What is the taxi fare for this package?", answer: "Cab fare starts from ₹12000 to ₹20000 depending on vehicle type and duration." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Is this suitable for family travel?", answer: "Yes, it is ideal for family and group pilgrimage trips." },
  { question: "Do you provide driver for entire trip?", answer: "Yes, all bookings include experienced drivers for the complete yatra." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during festive seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Milind Deshmukh",
    feedback: "The Navi Mumbai to 5 Jyotirlinga cab journey with Royal Route Cabs was very well organized and spiritually fulfilling. The long route was handled smoothly with comfortable travel throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Kulkarni",
    feedback: "Excellent experience for our 5 Jyotirlinga pilgrimage from Navi Mumbai. The cab was clean, the driver was cooperative, and the entire journey felt peaceful and stress-free.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-to-5-jyotirlinga-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai to 5 Jyotirlinga Darshan cab service with Royal Route Cabs for a spiritual Maharashtra pilgrimage covering major Lord Shiva Jyotirlinga temples. Available with AC cabs, Innova Crysta, Ertiga, SUV, and Tempo Traveller for comfortable multi-day tours.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "2800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14999", // indicative multi-day tour fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-to-5-jyotirlinga-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Navi Mumbai to 5 Jyotirlinga Darshan Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai to 5 Jyotirlinga Darshan cab tour with Royal Route Cabs. Spiritual Maharashtra Jyotirlinga Yatra with Innova, Ertiga, SUV, and Tempo Traveller options at best rates."
  />

  <meta
    name="keywords"
    content="navi mumbai to 5 jyotirlinga darshan cab, 5 jyotirlinga darshan cab from navi mumbai, navi mumbai 5 jyotirlinga yatra cab, 5 jyotirlinga tour package navi mumbai by cab, navi mumbai to jyotirlinga darshan taxi, 5 jyotirlinga darshan yatra cab, jyotirlinga darshan cab service navi mumbai, maharashtra 5 jyotirlinga darshan cab, jyotirlinga tour cab from navi mumbai, lord shiva jyotirlinga darshan cab, ac cab for 5 jyotirlinga darshan from navi mumbai, round trip cab navi mumbai to jyotirlinga, private cab for 5 jyotirlinga darshan, taxi booking for jyotirlinga darshan navi mumbai, best cab service for 5 jyotirlinga darshan, innova crysta for 5 jyotirlinga darshan, ertiga cab for jyotirlinga tour, tempo traveller 5 jyotirlinga darshan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitofivejyotilingadarshan;